import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';

import DependingObjects from '../../components/psc/lib/DependingObjects'
import CancelButton from '../../components/psc/lib/CancelButton'
import SaveButton from '../../components/psc/lib/SaveButton'
import DeleteButton from '../../components/psc/lib/DeleteButton'
import ErrorMessage from '../../components/psc/lib/ErrorMessage'

const ReportType = () => {
    let { objID } = useParams()
    const isNew = objID === "new" ? true : false
    objID = parseInt(objID,10)
    const objectUrl = '/v0/report_types' + (isNew ? '' : '/' + objID)

    // Fields
    const [name, setName] = useState('')
    const [reportTypeSections, setReportTypeSections] = useState([])
    
    // Read-only
    const [dependingObjects, setDependingObjects] = useState([])
    const [isUsed, setIsUsed] = useState(false)

    // Submit
    const [submitActive, setSubmitActive] = useState(false)
    const [error, setError] = useState(null)
    const [cloneActive, setCloneActive] = useState(false)

    useEffect(() => {
        if ( ! isNew) {
            fetchObject()
        }
    }, [isNew])

    const fetchObject = () => {
        fetch(objectUrl, { credentials: 'same-origin' })
            .then(function(response) {
                if (response.ok) {
                    return response.json()
                } else {
                    throw new Error(response.statusText)
                }
            })
            .then(function(json) {
                if(json.error) {
                    throw new Error(json.error)
                }

                fromBackend(json.result)
            })
            .catch(function(error) {
                console.log(error)
            })
    }

    const fromBackend = (obj) => {
        if (obj.report_type_sections) {
            obj.report_type_sections.map(function (m) {
                m.timestamp = m.id; // just to use same key 'timestamp' for all entries
            })
        }
        setName(obj.name)
        setReportTypeSections(obj.report_type_sections)
        setDependingObjects(obj.depending_objects)
        setIsUsed(obj.is_used)
    }

    const toBackend = () => {
        let internal_order = 1
        reportTypeSections.map(function (i) {
            i.internal_order = internal_order++
        })

        console.log('saving', reportTypeSections)
        return {
            name: name.trim(),
            report_type_sections: reportTypeSections,
        }
    }

    const validateBeforeSubmit = () => {
        let errors = []
        if ( ! name ) {
            errors.push('Name is required')
        }

        if ( errors.length > 0 ) {
            setError(errors)
            return false
        }

        return true
    }

    const handleSubmitError = (props) => {
        setSubmitActive(false)
        setError([ props.message ])
    }
    
    const handleSubmit = (event) => {
        if( event ) {
            event.preventDefault()
        }
        if( submitActive || !validateBeforeSubmit() ) {
            return null
        }

        setSubmitActive(true)

        return {
            objType: 'report_types',
            objID: objID,
            data: toBackend(),
        }
    }

    const clone = (event) => {
        if (event) {
            event.preventDefault()
        }

        if( cloneActive ) {
            return
        }
        setSubmitActive(true)
        setCloneActive(true)

        let url = objectUrl+'/clone'
        return {
            objType: 'report_types',
            objID: objID,
            url: url,
            data: toBackend(),
        }
    }

    const moveMemberUp = (member) => {
        let sections = [ ...reportTypeSections ]

        if( sections.length == 1 ) {
            // This is the only member
            return
        }

        let index = sections.findIndex(function (m) {
            if(m.timestamp == member.timestamp) { return true }
            return false;
        })
        if( index == 0 ) {
            return; // already at the top
        }

        sections[index] = sections[index-1]
        sections[index-1] = member

        sections[index].cssClassName = 'animated fadeIn'
        sections[index-1].cssClassName = 'animated fadeIn'

        setReportTypeSections(sections)
    }

    const moveMemberDown = (member) => {
        let sections = [ ...reportTypeSections ]

        if( sections.length == 1 ) {
            // This is the only member
            return
        }

        let index = sections.findIndex(function (m) {
            if(m.timestamp == member.timestamp) { return true }
            return false;
        })
        if( index+1 == sections.length ) {
            return; // already at the bottom
        }

        sections[index] = sections[index+1]
        sections[index+1] = member

        sections[index].cssClassName = 'animated fadeIn'
        sections[index+1].cssClassName = 'animated fadeIn'

        setReportTypeSections(sections)
    }

    const removeMember = (member) => {
        let members = reportTypeSections.filter(function (m) {
            if(m.timestamp == member.timestamp) { return false }
            return true;
        });
        setReportTypeSections(members)
    }

    const addMember = () => {
        // timestamp to have a unique key in the table
        let newMember = { id: 0, title: '', timestamp: new Date().getTime() }
        setReportTypeSections(reportTypeSections.concat([newMember]))
    }

    const updateMember = (field, member, event) => {
        var value = event.target.value;

        let members = reportTypeSections.filter(function (m) {
            if(m.timestamp == member.timestamp) {
                m[field] = value
            }
            return true;
        });
        setReportTypeSections(members)
    }

    let requiredIndicator = (<label className="form-required-star">&nbsp;*</label>);

    return (
        <div className="wrapper wrapper-content">
            <div className="row">
                <div className="col-lg-12">
                    <div className="ibox float-e-margins">
                        <div className="ibox-title">
                            <h2>Report Type: {name || '<New Report Type>'}</h2>
                        </div>
                        <div className="ibox-content">
                            <form className="form-horizontal" onSubmit={(e) => handleSubmit(e)}>
                                <div className="form-group">
                                    <label className="col-sm-2 control-label">Name
                                        {requiredIndicator}
                                    </label>
                                    <div className="col-sm-8">
                                        <input className="form-control" type="text"
                                            value={name}
                                            onChange={(e) => setName(e.target.value)}
                                            required 
                                        />
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label className="col-sm-2 control-label">Sections</label>
                                    <div className="col-sm-8">
                                        <table className="table table-striped table-bordered table-hover dataTable" >
                                            <thead>
                                                <tr>
                                                    <th>Section Title</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tfoot>
                                                <tr>
                                                    <th>Section Title</th>
                                                    <th>Action</th>
                                                </tr>
                                            </tfoot>
                                            <tbody>
                                                {reportTypeSections.map(function(obj) {
                                                        return (
                                                            <tr key={obj.id || obj.timestamp} className={obj.cssClassName}>
                                                                <td><input className="form-control" type="text" value={obj.title} onChange={event => updateMember("title", obj, event)} required /></td>
                                                                <td>
                                                                    <button type="button" className="btn btn-xs" onClick={event => moveMemberUp(obj, event)}><i className="fa fa-arrow-up"></i></button>
                                                                    &nbsp;
                                                                    <button type="button" className="btn btn-xs" onClick={event => moveMemberDown(obj, event)}><i className="fa fa-arrow-down"></i></button>
                                                                    &nbsp;

                                                                    {obj.is_used == true &&
                                                                     <DependingObjects list={obj.depending_objects} size="xs" />
                                                                    }
                                                                    {obj.is_used != true &&
                                                                     <button type="button" className="btn btn-xs btn-warning" onClick={event => removeMember(obj, event)}>Remove</button>
                                                                    }
                                                                </td>
                                                            </tr>
                                                        )
                                                    })}

                                            <tr>
                                                <td>&nbsp;</td>
                                                <td><button type="button" className="btn btn-xs btn-primary" onClick={addMember}>Add</button></td>
                                            </tr>

                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                
                                <div className="hr-line-dashed"></div>

                                <div className="form-group">
                                    <ErrorMessage
                                        error={error}
                                    />

                                    <div className="col-sm-10 col-sm-offset-2">
                                        <CancelButton />
                                        
                                        <SaveButton
                                            buttonVariant='primary'
                                            visible={true}
                                            spinnerActive={submitActive}
                                            label='Save Changes'
                                            onClick={handleSubmit}
                                            onError={handleSubmitError}
                                        />

                                        <SaveButton
                                            buttonVariant='warning'
                                            visible={!isNew}
                                            spinnerActive={cloneActive}
                                            label='Clone'
                                            onClick={clone}
                                            onError={handleSubmitError}
                                        />
                                        
                                        <DependingObjects list={dependingObjects} />

                                        <DeleteButton
                                           isHidden={isNew || isUsed}
                                           url={objectUrl}
                                           onError={handleSubmitError}
                                        />

                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default ReportType
